import React from 'react';
import { ImageWithModal } from '..';
import { conferences } from './conferences';
import Conference from './Conference';
import VideoPosters from './VideoPosters';
import Schedule from './Schedule';
import CTA from './CTA';
import Residents from './Residents';

export default function Congress() {
  return (
    <div className="xl:max-w-6xl mb-24 mt-12 mx-auto">
      <div className="w-full flex flex-row flex-wrap px-8 mb-16">
        <div className="w-full text-gray-900 pr-4 text-justify flex flex-col space-y-4">
          <h2 className="font-semibold text-3xl mt-4 text-blue-700">
            VI Congreso SVRID 2025
          </h2>
          <p className="mt-4 w-full text-base text-gray-600">
            La Sociedad Venezolana de Radiología e Imagenología
            Dentomaxilofacial tiene el honor de invitarles a participar en el V
            Congreso Nacional que se llevará a cabo los días viernes 07 y sabado
            08 de Noviembre en la Universidad Santa Maria en la Ciudad de
            Caracas - Venezuela
          </p>
          <p className="mt-4 w-full text-base text-gray-600">
            El programa diseñado con conferencias magistrales sobre la
            Radiologia Dentomaxilofacial y sus aplicaciones en las
            especialidades Odontológicas, serán dictadas por reconocidos
            profesionales.
          </p>
          <p className="mt-4 w-full text-base text-gray-600">
            Este año habrá la oportunidad de acceder al Congreso vía Online,
            para quienes no puedan asistir personalmente.
          </p>
          <p className="mt-4 w-full text-base text-gray-600">
            De igual manera tambien habrá una sesión de temas libres, así como
            la exposición comercial con destacadas empresas afines a la
            profesión.
          </p>
          <p className="mt-4 w-full text-base text-gray-600">
            Esperamos contar con su participación y sea un espacio para
            compartir e intercambiar conocimientos en esta especialidad.
          </p>
          <p className="mt-4 w-full text-base text-gray-600">
            Junta Directiva Sociedad Venezolana de Radiología e Imagenología
            Dentomaxilofacial. Período 2023-2025.
          </p>
          <h2 className="text-gray-900 font-semibold text-xl">
            CÓMO INSCRIBIRSE
          </h2>
          {/* <ol className="text-gray-600 list-inside list-decimal space-y-1">
            <li>
              Entrar al enlace de inscripción que se encuentra a continuación de
              este instructivo.
            </li>
            <li>
              Deberá seleccionar el tipo de inscripción. Odontólogo general y
              especialista, Técnico dental, Técnico radiólogo 100$. Estudiantes
              pre y postgrado 50$. Trabajo Científico 50$. Presionar boten
              INSCRIBIRSE.
            </li>
            <li>
              En la planilla de registro deberá completar los datos solicitados.
            </li>
            <li>
              Una vez completada la planilla de registro, deberá seleccionar
              tipo de pago y pulsar el botón de realizar el pedido. Si su pago
              es en efectivo o Zelle deberá seleccionar la primera opción.
            </li>
            <li>
              Una vez realizado el pago, recibirá un comprobante su número de
              inscripción (pedido).
            </li>
            <li>
              Recomendamos tener a mano su instrumento de pago antes de iniciar
              el registro en el enlace.
            </li>
            <li>
              En caso de presentar alguna duda podrá contactar al equipo de
              soporte técnico al WA{' '}
              <a
                href="https://wa.me/+584141314599"
                target="_blank"
                rel="noopener noreferrer"
              >
                +58 (414) 131 4599
              </a>
            </li>
            <li>
              <strong>NOTA:</strong> Los pagos en zelle y efectivo deberán
              realizarse antes del 8 de noviembre
            </li>
          </ol> */}

          {/* <div className="w-flex flex flex-wrap flex-row">
            <a
              href="https://eventusvip.com/svrid/"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 text-blue-700 inline-flex items-center mr-4"
            >
              Inscripción general
              <svg
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                className="w-4 h-4 ml-2"
                viewBox="0 0 24 24"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>
            <a
              href="https://eventusvip.com/svrid/"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 text-blue-700 inline-flex items-center mr-4"
            >
              Inscripción estudiantes
              <svg
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                className="w-4 h-4 ml-2"
                viewBox="0 0 24 24"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>
          </div> */}
          <div className="w-full grid grid-cols-3 gap-x-4">
            {/* <ImageWithModal src="v-congreso-svrid-00001.png" vertical />
            <ImageWithModal src="v-congreso-svrid-00003.png" vertical />
            <ImageWithModal src="v-congreso-svrid-00002.png" vertical /> */}
          </div>
        </div>
      </div>
      {/* <VideoPosters /> */}
      {/* <Schedule /> */}
      {/* <div className="text-gray-600 body-font my-24">
        <div className="container px-5 mx-auto">
          <div className="flex flex-wrap w-full mb-20">
            <div className="lg:w-1/2 w-full mb-6 lg:mb-0">
              <h2 className="sm:text-3xl text-2xl font-medium mb-2 text-gray-700">
                Conferencias
              </h2>
              <div className="h-1 w-20 bg-blue-500 rounded" />
            </div>
          </div>
          <div className="flex flex-wrap -m-4">
            {conferences.map((conference) => (
              <div className="p-4 md:w-1/3" key={conference.id}>
                <Conference conference={conference} />
              </div>
            ))}
          </div>
        </div>
      </div> */}
      {/* <Residents /> */}
      <CTA />
    </div>
  );
}
